export class HandlerError extends Error {
  statusCode: number;
  code?: string;
  errorInfo?: { [key: string]: any };

  constructor(
    message: string,
    statusCode: number,
    code: string,
    errorInfo?: { [key: string]: any }
  ) {
    super(message);
    this.statusCode = statusCode;
    this.code = code;
    this.errorInfo = errorInfo;
  }

  private generateErrorResponseBody() {
    return {
      success: false,
      statusCode: this.statusCode,
      code: this.code,
      error: this.message,
      message: this.message,
      errorInfo: this.errorInfo,
    };
  }

  generateHandlerResponse() {
    return generateHandlerResponse(
      this.statusCode,
      this.generateErrorResponseBody()
    );
  }
}

export const Errors = {
  INTERNAL_SERVICE_ERROR: "Internal Service Error",
  INVALID_BODY: "Invalid body",
  EXISTING: "Existing",
  NOT_FOUND: "Not found",
  VALIDATION: "Validation",
  ITEM_VALIDATION: "Item validation",
  TOO_MANY_ATTEMPTS: "Too many attempts",
  TOO_CLOSE_TO_EXPIRATION: "Too close to expiration",
  NOT_AUTHORIZED: "Not authorized",
  NOT_LOGGED_IN: "Not logged in",
} as const;

const headers = {
  "Content-Type": "application/json",
  "Access-Control-Allow-Origin": "*",
  "Access-Control-Allow-Credentials": true,
};

export const generateHandlerResponse = (
  statusCode: number,
  body: any,
  extraHeaders?: { [key: string]: string }
) => {
  return {
    statusCode,
    headers: { ...headers, ...extraHeaders },
    body: JSON.stringify(body, null, 2),
  };
};
